import React, { useState, useEffect } from "react";
import axios from "axios";
import { Card, Table,Row, Form, Col , Button,Tabs, Tab } from "react-bootstrap";
import { useParams } from "react-router-dom";
import { handle401 } from "../../../utils/handleAuthError";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import Swal from "sweetalert2";

const BASE_URL = "https://sutmmg.codydeasoftech.in/api";

const PaymentTransactionList = () => {
  const { id: vendorId } = useParams(); // gets vendor_id from route
  const [transactions, setTransactions] = useState([]);
  const [loading, setLoading] = useState(false);
  const [vendorName, setVendorName] = useState("");
  const [type, setType] = useState("");
  const [activeTab, setActiveTab] = useState("CREDIT");
  // Pagination states
  const [page, setPage] = useState(1);
  const [perPage, setPerPage] = useState(10);
  const [totalRecords, setTotalRecords] = useState(0);
  const [totalPages, setTotalPages] = useState(1);
  const [jobList, setJobList] = useState([]);
  const [paymentType, setPaymentType] = useState("");
  const [searched, setSearched] = useState(false);

  const today = new Date().toISOString().split("T")[0]; // "2026-03-13"
  const formattedToday = new Date(today)
  .toLocaleDateString("en-GB")
  .replace(/\//g, "-");
  // Format date
  const formatDate = (date) => {
    if (!date) return "-";
    const d = new Date(date);
    if (isNaN(d)) return "-";
    const day = String(d.getDate()).padStart(2, "0");
    const month = String(d.getMonth() + 1).padStart(2, "0");
    const year = d.getFullYear();
    return `${day}-${month}-${year}`;
  };


const handleReset = () => {
  setType("");
  setPaymentType("");
  setPerPage(10);
  setPage(1);

  setTransactions([]);
  setSearched(false);
};


  // Fetch transactions

const handleExportExcel = async () => {
  try {
    const token = localStorage.getItem("token");

    let allData = [];
    let pageNo = 1;
    let totalPages = 1;

    do {
      const payload = {
        vendor_id: vendorId || "",
        type: type || "",
        page: pageNo,
        per_page: 100
      };

      const res = await axios.post(
        `${BASE_URL}/paymentsTransactionsList`,
        payload,
        { headers: { Authorization: `Bearer ${token}` } }
      );

      const pageData = res.data?.data || [];
      const totalRecords = res.data?.total_records || 0;

      allData = [...allData, ...pageData];

      totalPages = Math.ceil(totalRecords / 100);

      pageNo++;

    } while (pageNo <= totalPages);

    if (!allData.length) {
      Swal.fire("No Data", "Nothing to export", "warning");
      return;
    }

    const formattedData = allData.map((t, index) => ({
      "SL No": index + 1,
      Date: formatDate(t.created_at),
      Item: t.item_name || "-",
      Job: t.action_name || "-",
      Size: t.size || "-",
      Quantity: t.quantity || "-",
      Type: t.type,
      "Amount (₹)": t.amount,
      "Outstanding Balance (₹)": t.current_amount,
    }));

    const worksheet = XLSX.utils.json_to_sheet(formattedData);
    const workbook = XLSX.utils.book_new();

    XLSX.utils.book_append_sheet(workbook, worksheet, "Ledger");

    const excelBuffer = XLSX.write(workbook, {
      bookType: "xlsx",
      type: "array"
    });

    const file = new Blob([excelBuffer], {
      type:
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8"
    });

    saveAs(file, `Payment_Ledger_${vendorName}_${formattedToday}.xlsx`);

  } catch (error) {
    if (handle401(error)) return;

    Swal.fire(
      "Error",
      error?.response?.data?.message || "Failed to export data",
      "error"
    );
  }
};

const fetchJobRates = async () => {
  try {
    const token = localStorage.getItem("token");

    const res = await axios.get(
      `${BASE_URL}/jobWorkTypeList`,

      {
        headers: { Authorization: `Bearer ${token}` },
      }
    );

    const data = res.data?.data.jobWorkTypeList || [];

    // 👉 transform for your UI


    setJobList(data);
  } catch (err) {
    if (handle401(err)) return;
    console.error("Job Rate Fetch Error:", err);
  }
};

const fetchTransactions = async (
  vendor_id,
  pageNo = 1,
  perPageValue = perPage,
  tabType = activeTab,
  jobWorkType = type
) => {
  setLoading(true);

  try {
    const token = localStorage.getItem("token");

    let url = "";
    let payload = {};

    if (tabType === "CREDIT") {
      url = `${BASE_URL}/paymentsTransactionsListEarnings`;
      payload = {
        vendor_id,
        job_work_type_id: jobWorkType || "",
        page: pageNo,
        per_page: perPageValue
      };
    } else {
      url = `${BASE_URL}/paymentsTransactionsList`;
      payload = {
        vendor_id,
        type: paymentType,  // <-- Use paymentType here
        page: pageNo,
        per_page: perPageValue
      };
    }

    const res = await axios.post(url, payload, {
      headers: { Authorization: `Bearer ${token}` }
    });

    const data = res.data?.data || [];
    setTransactions(data);

    setPage(res.data.page || pageNo);
    setTotalRecords(res.data.total_records || data.length);
    setTotalPages(Math.ceil((res.data.total_records || data.length) / perPage));

    setVendorName(data.length ? data[0].vendors_master_name : "");
  } catch (err) {
    if (handle401(err)) return;
    console.error("Transactions Fetch Error:", err);
  } finally {
    setLoading(false);
  }
};

  // Generate page numbers for pagination
  const getPageNumbers = () => {
    const pages = [];
    const max = 5; // max pages to show
    let start = Math.max(1, page - 2);
    let end = Math.min(totalPages, start + max - 1);
    for (let i = start; i <= end; i++) pages.push(i);
    return pages;
  };

  const theadStyle = {
    padding: "5px",
    fontWeight: "600",
    letterSpacing: "0.5px",
    backgroundColor: "#edf7fe",
    borderBottom: "1px solid black",
    textAlign: "center",
  };

// useEffect(() => {
//   fetchTransactions(vendorId, 1, perPage, "CREDIT", "");
// }, [vendorId]);

  useEffect(() => {

    fetchJobRates();

}, []);

  return (
    <div className="container mt-4"  style={{ maxWidth: 1550 }}>


      <Card
  className="mb-4 border-0"
  style={{
    background: "linear-gradient(135deg, #E3F2FD, #ffffff)",
    borderRadius: "14px",
    boxShadow: "0 8px 25px rgba(21,101,193,0.15)",
  }}
>
  <div
    className="px-4 py-3 text-white"
    style={{
      background: "linear-gradient(90deg,#0D47A1,#1565C1)",
    }}
  >
    <h5 className="mb-0 fw-bold">
      <i className="fa-solid fa-filter me-2"></i>
      Job Worker Payment Ledger Of {vendorName}
    </h5>
  </div>

  <Card.Body className="px-4 py-4">
    <Row className="align-items-center">

      {/* TYPE / JOB FILTER */}
<Col md={3}>
  <Form.Group className="mb-3">
    {activeTab === "CREDIT" ? (
      <>
        <Form.Label className="fw-semibold text-dark">Select Job <span className="text-danger">*</span></Form.Label>
        <Form.Select
          value={type}
          onChange={(e) => setType(e.target.value)}
          style={{ borderRadius: "10px", border: "2px solid #1565C1" }}
        >
          <option value="">All</option>
          {jobList.map((v) => (
            <option key={v.id} value={v.id}>{v.action_name}</option>
          ))}
        </Form.Select>
      </>
    ) : (
      <>
        <Form.Label className="fw-semibold text-dark">Select Type  <span className="text-danger">*</span></Form.Label>
        <Form.Select
          value={paymentType}
          onChange={(e) => setPaymentType(e.target.value)}
          style={{ borderRadius: "10px", border: "2px solid #1565C1" }}
        >
          <option value="">Select Type</option>
          <option value="DEBIT">DEBIT</option>
          <option value="CREDIT">CREDIT</option>
        </Form.Select>
      </>
    )}
  </Form.Group>
</Col>

      {/* PER PAGE */}
      <Col md={3}>
        <Form.Group className="mb-3">
          <Form.Label className="fw-semibold text-dark">
            Record Showing
          </Form.Label>

          <Form.Select
            value={perPage}
            onChange={(e) => {
              const value = Number(e.target.value);
              setPerPage(value);
              setPage(1);
              fetchTransactions(vendorId, 1, value,type);
            }}
            style={{
              borderRadius: "10px",
              border: "2px solid #1565C1",
            }}
          >
            <option value={10}>10 Per Page</option>
            <option value={25}>25 Per Page</option>
            <option value={50}>50 Per Page</option>
            <option value={100}>100 Per Page</option>
          </Form.Select>
        </Form.Group>
      </Col>

      {/* BUTTONS */}
      <Col md={4} className="d-flex gap-3 mt-3">

        <Button
          className="w-50 fw-semibold text-white"
          style={{
            background: "#1565C1",
            border: "none",
            borderRadius: "10px",
          }}
onClick={() => {
  setSearched(true);
  fetchTransactions(vendorId, 1, perPage, activeTab, type);
}}
        >
          <i className="fa-solid fa-magnifying-glass me-2"></i>
          Search
        </Button>

        <Button
          className="w-50 fw-semibold text-white"
          style={{
            background: "#E53935",
            border: "none",
            borderRadius: "10px",
          }}
            onClick={handleReset}
        >
          <i className="fa-solid fa-arrow-rotate-left me-2"></i>
          Reset
        </Button>

      </Col>

    </Row>
  </Card.Body>
</Card>


{/* <Button
    style={{
      background: "#43A047",
      border: "none",
      borderRadius: "8px",
    }}
    className="px-4 mb-4"
    onClick={handleExportExcel}
  >
    <i className="fa-solid fa-file-excel me-2"></i> Export to Excel
  </Button> */}



 <Tabs
  activeKey={activeTab}
  onSelect={(k) => {
    setActiveTab(k);
    setTransactions([]);

    setPage(1);            // ✅ reset page
    setSearched(false);
    fetchTransactions(vendorId, 1, perPage, k, type);
  }}
  className="underline-tabs mb-4"
>
  <Tab
    eventKey="CREDIT"
    title={
      <span className="tab-title">
        <i className="fa-solid fa-arrow-down me-2"></i>
        Earnings
      </span>
    }
  />

  <Tab
    eventKey="DEBIT"
    title={
      <span className="tab-title">
        <i className="fa-solid fa-arrow-up me-2"></i>
        Payments
      </span>
    }
  />
</Tabs>

      <Card className="border-0">

  {/* ====================== LOADER ====================== */}
  {loading && (
    <div className="loader-wrapper text-center my-4">
      <div className="blue-spinner"></div>
      <p className="loading-text">Loading...</p>
    </div>
  )}

  {/* ====================== TABLE ====================== */}
  {!loading && (
    transactions.length > 0 ? (
      <>
        <Table bordered hover responsive striped>
          <thead>
            <tr>
              <th style={theadStyle}>SL</th>
              <th style={theadStyle}>Date</th>
             {activeTab !== "CREDIT" && (
      <th style={theadStyle}>Item</th>
    )}
              <th style={theadStyle}>Job</th>

    {activeTab !== "CREDIT" && (
      <th style={theadStyle}>Member</th>
    )}

    {activeTab !== "CREDIT" && (
      <th style={theadStyle}>Size</th>
    )}

              <th style={theadStyle}>Quantity</th>
              <th style={theadStyle}>Rate</th>
 {activeTab !== "CREDIT" && (
      <th style={theadStyle}>Outstanding Balance</th>
    )}              <th style={theadStyle}>Type</th>

            </tr>
          </thead>

          <tbody>
            {transactions.map((t, index) => (
              <tr key={t.id} className="text-center">
                <td>{(page - 1) * perPage + index + 1}</td>
                <td>{formatDate(t.created_at)}</td>
{activeTab !== "CREDIT" && (
        <td>{t.item_name || "_"}</td>
      )}                <td>{t.action_name || "_"}</td>

      {activeTab !== "CREDIT" && (
        <td>{t.members || "_"}</td>
      )}
                {activeTab !== "CREDIT" && (
        <td>{t.size || "_"}</td>
      )}
                <td>{t.quantity || "_"}</td>
                <td>₹ {t.amount}</td>
                {activeTab !== "CREDIT" && (
        <td style={{ color: "green", fontWeight: 600 }}>
          ₹ {t.current_amount}
        </td>
      )}
                <td>
                  {t.type === "DEBIT" ? (
                    <span className="text-success">
                      <i className="fa-solid fa-arrow-up"></i> DEBIT
                    </span>
                  ) : (
                    <span className="text-danger">
                      <i className="fa-solid fa-arrow-down"></i> CREDIT
                    </span>
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </Table>

        {/* ====================== PAGINATION ====================== */}
        {totalPages > 1 && (
          <div className="d-flex justify-content-center mt-4">
            <nav>
              <ul className="pagination shadow-sm">

                <li className={`page-item ${page === 1 ? "disabled" : ""}`}>
                  <button
                    className="page-link"
                    disabled={page === 1}
                    onClick={() => fetchTransactions(vendorId, 1)}
                  >
                    «
                  </button>
                </li>

                <li className={`page-item ${page === 1 ? "disabled" : ""}`}>
                  <button
                    className="page-link"
                    disabled={page === 1}
                    onClick={() => fetchTransactions(vendorId, page - 1)}
                  >
                    ‹
                  </button>
                </li>

                {getPageNumbers().map((p) => (
                  <li key={p} className={`page-item ${page === p ? "active" : ""}`}>
                    <button
                      className="page-link"
                      onClick={() => fetchTransactions(vendorId, p)}
                    >
                      {p}
                    </button>
                  </li>
                ))}

                <li className={`page-item ${page === totalPages ? "disabled" : ""}`}>
                  <button
                    className="page-link"
                    disabled={page === totalPages}
                    onClick={() => fetchTransactions(vendorId, page + 1)}
                  >
                    ›
                  </button>
                </li>

                <li className={`page-item ${page === totalPages ? "disabled" : ""}`}>
                  <button
                    className="page-link"
                    disabled={page === totalPages}
                    onClick={() => fetchTransactions(vendorId, totalPages)}
                  >
                    »
                  </button>
                </li>

              </ul>
            </nav>
          </div>
        )}
      </>
    ) : (
      <div className="text-center my-4 text-muted">

  {!searched && activeTab === "CREDIT" && (
    <span>Please select a job</span>
  )}

  {!searched && activeTab === "DEBIT" && (
    <span>Please select a type</span>
  )}

  {searched && "No Data Found"}

</div>
    )
  )}

</Card>
    </div>
  );
};

export default PaymentTransactionList;
